<template>
  <layout-supervise :top="0">
    <Map dim="3" />
    <div class="line-container" ref="line"></div>
    <van-cell-group class="group">
      <van-cell title="工作落实情况统计" to="/superviseRisk" is-link />
    </van-cell-group>
  </layout-supervise>
</template>
<script>
import { useRouter } from 'vue-router'
import { ref, onMounted, computed } from 'vue'
import { useStore } from 'vuex'
import { getStreetStatInfo } from '@/api/supervise'
import { useGetData } from '@/hooks/useGetData'
import * as echarts from 'echarts'
export default {
  name: 'superviseLeaderHome',
  setup() {
    // 初始化list
    const store = useStore()
    const streetCode = computed(() => store.state.roleInfo.companyId)
    const router = useRouter()
    const handleHomeClick = () => {
      router.push('/welcome')
    }
    const trajectory = ref(null)
    const pointList = [
      {
        text: '2021-11-10 13:22:13',
        longitude: 123.446949,
        latitude: 41.723139
      },
      {
        text: '2021-11-10 15:36:24',
        longitude: 123.459995,
        latitude: 41.735693
      },
      {
        text: '2021-11-13 09:12:06',
        longitude: 123.485229,
        latitude: 41.673536
      },
      {
        text: '2021-11-16 11:36:22',
        longitude: 123.402969,
        latitude: 41.723908
      }
    ]

    const line = ref(null)
    onMounted(() => {
      const chart = echarts.init(line.value)
      // 折线图数据
      const xAxis = ref([])
      const yUser = ref([])
      const yIllUser = ref([])
      const yUserUse = ref([])
      const yIllUserUse = ref([])
      useGetData(getStreetStatInfo, data => {
        data.forEach(item => {
          xAxis.value.push(item.statDt)
          yUser.value.push(item.userCount)
          yIllUser.value.push(item.illeUserCount)
          yUserUse.value.push(item.userUseage)
          yIllUserUse.value.push(item.illeUserUseage)
        })
        chart.setOption({
          title: {
            text: '7日用户用量趋势表'
          },
          tooltip: {
            trigger: 'axis'
          },
          grid: {
            left: '10%',
            right: '10%',
            bottom: '10%'
          },
          xAxis: {
            type: 'category',
            data: xAxis.value
          },
          yAxis: {
            type: 'value'
          },
          series: [
            {
              name: '违法用户数',
              type: 'line',
              data: yIllUser.value
            },
            {
              name: '合法用户数',
              type: 'line',
              data: yUser.value
            },
            {
              name: '日违法用量',
              type: 'line',
              data: yIllUserUse.value
            },
            {
              name: '日合法用量',
              type: 'line',
              data: yUserUse.value
            }
          ]
        })
      })(streetCode.value)
    })
    return {
      handleHomeClick,
      trajectory,
      pointList,
      line,
      streetCode
    }
  }
}
</script>

<style lang="scss" scoped>
.group {
  margin-top: 16px;
}
.line-container {
  padding-top: 10px;
  background-color: #fff;
  margin-top: 16px;
  height: 230px;
}
</style>
